import rootApi from '@utils/baseAPI/WrapperApi';

export const apiGetAllDMA = (params) => rootApi.get('api/dmas', { params });
export const apiGetDMAById = (id) => rootApi.get(`api/dma/${id}`);
export const apiCreateDMA = (data) => rootApi.post('api/dma', data);
export const apiUpdateDMA = (id, data) => rootApi.put(`api/dma/${id}`, data);
export const apiDeleteDMA = (id) => rootApi.delete(`api/dma/${id}`);
export const apiGetDMAMonitoring = (params) => rootApi.get('api/dma-monitoring', { params });
export const apiGetDMAMonitoringChart = (params) =>
  rootApi.get('api/dma-monitoring', { params: { ...params, page: 1, size: 1000 } });
export const apiExportDMAMonitoring = (params) =>
  rootApi.get('api/dma-monitoring/export', { params, responseType: 'blob' });
